import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  plan: null, // Main subscription plan (one-time selection)
  addons: [],
  totalPrice: 0, // Total price including plan + add-ons
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setPlan: (state, action) => {
      state.plan = action.payload;
      state.totalPrice = action.payload.price; // Base price from plan
    },
    setAddons: (state, action) => {
      state.addons = action.payload;
    },
    addAddon: (state, action) => {
      const addon = action.payload;
      const existingAddon = state.addons.find((a) => a?.id === addon.id);

      if (existingAddon) {
        existingAddon.quantity += 1;
      } else {
        state.addons.push({ ...addon, quantity: 1 });
      }

      state.totalPrice += addon.price / 100;
    },
    removeAddon: (state, action) => {
      const addonId = action.payload;
      const addon = state.addons.find((a) => a.id === addonId);

      if (addon && addon.quantity > 0) {
        state.totalPrice -= (addon.price / 100) * addon.quantity;
        addon.quantity = 0;
      }
    },

    updateAddonQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const addon = state.addons.find((a) => a?.id === id);

      if (addon) {
        const priceDifference =
          ((quantity - addon.quantity) * addon.price) / 100;
        addon.quantity = quantity;
        state.totalPrice += priceDifference;
      }
    },

    clearCart: (state) => {
      state.plan = null;
      state.addons = [];
      state.totalPrice = 0;
    },
  },
});

export const {
  setPlan,
  addAddon,
  removeAddon,
  updateAddonQuantity,
  setAddons,
  clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;
